import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  template: require('./vehicle-visuals.actions.component.html')
})
export class VehicleVisualsActionsComponent {
  @Input() record: any;

  @Output() onAttachClick: EventEmitter<any> = new EventEmitter();
  @Output() onEmailClick : EventEmitter<any> = new EventEmitter();
  @Output() onLaunchClick: EventEmitter<any> = new EventEmitter();
}